import { useEffect } from 'react';
import PageHero from '@/components/PageHero';
import '../styles/solutions.css';

const AUDIENCES = [
  {
    tag: '政府监管',
    title: '给监管方一套可核查的台账',
    desc: '省、市、县各级主管部门可以按行政区划查看在栏牛只分布、免疫与检疫执行情况，抽查时不再依赖纸质台账。',
    features: [
      '牛只台账与分布地图',
      '检疫、免疫记录在线核查',
      '出栏与调运流向可追溯',
      '统计报表按需导出',
    ],
    accent: 'gov',
  },
  {
    tag: '养殖企业',
    title: '把日常生产记录变成可用的数据',
    desc: '适合养殖园区与规模牧场，饲喂、防疫、称重、出栏按牛只归档，便于核算批次成本与繁殖表现。',
    features: [
      '多牧场统一管理',
      '批次入栏与出栏记录',
      '防疫流程在线执行',
      '生长与饲料数据统计',
    ],
    accent: 'park',
  },
  {
    tag: '采购与加工',
    title: '买牛之前先看清这头牛经历过什么',
    desc: '面向屠宰、加工与贸易企业，采购时可在线核验供应商资质、牛只检疫状态与过往交易记录。',
    features: [
      '供应商与牛只档案核验',
      '线上挂牌与竞价采购',
      '存证记录一键验真',
      '运输与交割进度跟踪',
    ],
    accent: 'biz',
  },
  {
    tag: '消费者',
    title: '扫码就知道这块肉来自哪头牛',
    desc: '在 beef 包装或销售点扫描二维码，可查看对应牛只的品种、养殖场、免疫与出栏日期。',
    features: [
      '扫码查看牛只完整履历',
      '养殖场与检疫信息公开',
      '交易环节上链可查',
    ],
    accent: 'buyer',
  },
];

export default function Solutions() {
  useEffect(() => {
    document.title = '解决方案 | 云牛集·山东牛产业智慧平台';
  }, []);

  return (
    <>
      <PageHero
        title="解决方案"
        desc="平台按使用者角色划分功能模块，不同角色登录后看到的内容与操作各不相同。"
      />

      <section className="section">
        <div className="container">
          <div className="section-head">
            <h2>四类使用角色</h2>
            <p className="section-desc">监管方、企业、买家各有独立入口，以下是各自能做的事</p>
          </div>
          <div className="sol-grid">
            {AUDIENCES.map((item) => (
              <article key={item.tag} className={`sol-card ${item.accent}`}>
                <span className="sol-tag">{item.tag}</span>
                <h3>{item.title}</h3>
                <p className="sol-desc">{item.desc}</p>
                <ul className="sol-features">
                  {item.features.map((f) => (
                    <li key={f}>{f}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-head">
            <h2>平台的设计取舍</h2>
          </div>
          <div className="why-grid">
            <div className="why-item">
              <strong>01</strong>
              <h3>记录先于功能</h3>
              <p>先把每一头牛的基础档案建起来，后续功能才有数据基础。档案字段按实际养殖流程设计。</p>
            </div>
            <div className="why-item">
              <strong>02</strong>
              <h3>存证不替代监管</h3>
              <p>区块链存证只保证记录未被篡改，采信仍需人工审核与配套制度，平台不替监管方做决定。</p>
            </div>
            <div className="why-item">
              <strong>03</strong>
              <h3>预警给出依据</h3>
              <p>健康与价格预警会附带触发原因和数据区间，供使用者判断，不直接代替决策。</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
